import { TextSize, Weight } from 'components'

import CloseIcon from 'assets/close-icon.svg?react'
import { GLOBAL_COLORS } from 'theme'
import styled from 'styled-components'

export const WelcomeWrapper = styled.div`
  position: absolute;
  border: 0px;
  right: 85px;
  bottom: 20px;
  z-index: 2;
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  ${({ theme }) => theme.mediaWidth.Desktop`
    right: calc(calc(100% - 1160px) / 2);
  `}
  @media (max-width: 1200px) {
    right: 70px;
  }
  ${({ theme }) => theme.mediaWidth.Small`
    right: 0px;
  `}
`
export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 30px;
  background-color: ${({ theme }) => theme.bg};
  width: 260px;
  height: 112px;
  border-radius: 20px;
`

export const WelcomeTitleArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const WelcomeTitle = styled.span`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  line-height: 130%;
`

export const Close = styled(CloseIcon)`
  width: 10px;
  height: 10px;
  cursor: pointer;
  path {
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const WelcomeContent = styled.span`
  color: ${({ theme }) => theme.greySlate};
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
`

export const WelcomeButton = styled.span`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  letter-spacing: -0.14px;
  cursor: pointer;
  transition: 0.4s all;
  &:hover {
    color: ${GLOBAL_COLORS.coralBlue};
  }
  &:active {
    opacity: 0.7;
    color: ${GLOBAL_COLORS.coralBlue};
  }
`
